import { useState, useEffect } from 'react';
import { append } from './i18n';

// Tracks namespaces already merged into the dict so we never re-fetch.
const loaded = new Set();

export function usePageLocale(namespace) {
  const [ready, setReady] = useState(loaded.has(namespace));

  useEffect(() => {
    if (loaded.has(namespace)) return;
    const locale = localStorage.getItem('userLanguage') || 'ua';
    import(`../../localization/${locale}.${namespace}.json`)
      .then(m => {
        append(m.default);
        loaded.add(namespace);
        setReady(true);
      });
  }, [namespace]);

  return ready;
}
